import {createRouter, createWebHistory} from "vue-router";

import test from "@/page/test.vue";
import errorPage from "@/page/errorPage";
import noPermission from "@/page/noPermission.vue";
import {getCurPage} from "@/page/mainWrap/menu/menuTool.js";

export const page = {
  comTest:"/comTest",
  login:'/login',
  index:'/dataMap',
  noPermission:"/noPermission"
}

const routes = [
  {path: '/login', name: 'login', component: () => import('@/page/login/login')},
  {path: '/', redirect: '/dataMap' },
  {path: '/test', component: test},
  {path: '/:pathMatch(.*)*', name: 'NotFound', component: errorPage},
  {path: '/publicMap', name: 'publicMap', component: () => import('@/page/dataMap/publicMap.vue'), },
  {path: '/aMapDemo', name: 'aMapDemo', component: () => import('@/page/dataMap/aMapDemo.vue'), },
  {path: '/leafMapDemo', name: 'leafMapDemo', component: () => import('@/page/leafMapDemo/leafMapDemo.vue'), },
  {path: '/selectLonLat', name: 'selectLonLat', component: () => import('@/page/business/selectLonLat/selectLonLat.vue'), },

  {path:'/mainWrap', component: () => import('@/page/mainWrap/mainWarp.vue'), children: [
      {path: '/dataMap', name: 'dataMap', component: () => import('@/page/dataMap/adminMap.vue'), },
      {path: '/medical', name: 'medical', component: () => import('@/page/business/medical/medicalTable.vue')},
      {path: '/education', name: 'education', component: () => import('@/page/business/education/educationTable.vue')},

      // 用户管理
      {path: '/userManage/account', name: 'account', component: () => import('@/page/userManage/account/account')},
      {path: '/userManage/role', name: 'role', component: () => import('@/page/userManage/role/roleManager.vue')},

      // 系统设置
      {path: '/setting/manual', name: 'manual', component: () => import('@/page/setting/manual/manual')},
      {path: '/setting/log', name: 'log', component: () => import('@/page/setting/log/log')},
      {path: '/setting/loginLog', name: 'loginLog', component: () => import('@/page/setting/log/loginLog')},
      {path: '/setting/operationLog', name: 'operationLog', component: () => import('@/page/setting/log/operationLog')},

      // 无权限页
      {path: '/noPermission', name: 'noPermission', component: noPermission},

    ]
  }
]

export function toPage(page, query) {
  router.push({path: page, query}).then()
}


export const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes
})

const noAuthPageList = [
  'index',
  'noPermission',
  'login',
]

router.beforeEach(to => {
  if (noAuthPageList.includes(to.name)) {
    return
  }
  let targetPage = getCurPage(to.name)
  if (targetPage === undefined) {
    return {name: 'noPermission'}
  }
})
